import * as React from 'react';
import ListItemIcon from '@material-ui/core/ListItemIcon';

const CustomListItemIcon = (props) => {
    return <ListItemIcon {...props} />;
};

export { CustomListItemIcon as ListItemIcon };
